<template>
  <div>
    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
      <el-button-group class="float-right">
        <router-link v-if="this.$store.getters.Yetki.yonetim>0 && Kisi_id"
                     class="el-button YeniBtn el-button--success el-button--small" :to="'/yonetim/kisi/'+Kisi_id">Kişi
          Ekranı
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="4">
          <VezneListe :Yenile="Yenile"></VezneListe>
        </el-col>
        <el-col :span="20">
          <VezneKisiTahsilat @SayfaAdi="SayfaAdiGetir($event)" @Yenile="KisiGetir($event)" :Kisi_id="Kisi_id" v-if="Kisi_id"></VezneKisiTahsilat>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import VezneListe from "../../components/Pack/Vezne/VezneListe";
import VezneKisiTahsilat from "../../components/Pack/Vezne/VezneKisiTahsilat";

export default {
  components: {VezneKisiTahsilat, VezneListe},
  data() {
    return {
      Kisi_id: null,
      SayfaAdi: "Tahsilat",
      Yenile: false
    }
  },
  methods: {
    SayfaAdiGetir(event) {
      this.SayfaAdi = event;
    },
    KisiGetir(event) {
      this.Yenile = event;
    },
  },
  created() {
    if (this.$route.params.Kisi_id) {
      this.Kisi_id = this.$route.params.Kisi_id;
    }
  },
  computed: {
    KisiSecim() {
      return this.$route.path
    },
  },
  watch: {
    KisiSecim() {
      this.Kisi_id = this.$route.params.Kisi_id;
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/Vezne/Tahsilat.vue